<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card
      :loading="formProcessing"
    >
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="bankName"
                  required
                  label="Bank Name"
                  :error-messages="bankNameErrors"
                  @input="v$.bankName.$touch()"
                  @blur="v$.bankName.$touch()"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="aba"
                  required
                  label="ABA"
                  type="number"
                  :error-messages="abaErrors"
                  @input="v$.aba.$touch()"
                  @blur="v$.aba.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, integer } from '@vuelidate/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          bankName: '',
          aba: '',
        };
      },
    },
    action: {
      type: String,
      default: 'add',
    },
  },
  setup() { return { v$: useVuelidate() }; },
  validations: {
    bankName: {
      required,
    },
    aba: {
      required,
      integer,
    },
  },
  data() {
    return {
      valid: false,
      id: null,
      bankName: '',
      aba: '',
      formProcessing: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formTitle() {
      return this.action === 'add' ? 'Add New Bad ABA' : 'Edit Bad ABA';
    },
    bankNameErrors() {
      const errors = [];

      if (!this.v$.bankName.$dirty) {
        return errors;
      }

      if (this.v$.bankName.required.$invalid) {
        errors.push('Bank Name is required.');
      }

      return errors;
    },
    abaErrors() {
      const errors = [];

      if (!this.v$.aba.$dirty) {
        return errors;
      }

      if (this.v$.aba.required.$invalid) {
        errors.push('ABA is required.');
      }

      if (this.v$.aba.integer.$invalid) {
        errors.push('ABA must be a integer.');
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.bankName = this.editedItem.bank_name;
      this.aba = this.editedItem.aba;
    },
  },
  methods: {
    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;

        let request = '';

        const data = {
          aba: this.aba,
          bankName: this.bankName,
        };

        if (this.action === 'add') {
          request = this.$axios.post('/api/v1/bad-aba', data);
        } else {
          request = this.$axios.put(`/api/v1/bad-aba/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.bank_name} has been saved.`,
              color: 'green',
            });
          })
          .catch((error) => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });

            console.error(error);
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');

      this.bankName = '';
      this.aba = '';
    },
    ...mapActions('notification', ['setNotification']),
  },
};
</script>

<style></style>
